import type {HTMLAttributes} from 'react';
import type {MenuListProps} from '@mui/material/MenuList';
import TablePagination from '@mui/material/TablePagination';

import {MHPaginationActions} from './MHPaginationActions';
import {MHPaginationProps} from './types';

import styles from './mhPagination.module.scss';

const MH_TABLE_ROWS_PER_PAGE_SELECT = 'mh-table-rows-per-page-select';
const MH_TABLE_ROWS_PER_PAGE_MENU_LIST = 'mh-table-rows-per-page-menu-list';

const rowsPerPageSelectDisplayProps = {
    'data-testid': MH_TABLE_ROWS_PER_PAGE_SELECT,
} as HTMLAttributes<HTMLDivElement>;

const rowsPerPageMenuListProps = {
    'data-testid': MH_TABLE_ROWS_PER_PAGE_MENU_LIST,
} as Partial<MenuListProps>;

export const MHPagination = ({
    count,
    size,
    page,
    onPageChange,
    onChangeRowsPerPage,
    rowsPerPageOptions = [10, 25, 50],
}: MHPaginationProps) => (
    <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={size}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onChangeRowsPerPage}
        SelectProps={{
            SelectDisplayProps: rowsPerPageSelectDisplayProps,
            MenuProps: {
                MenuListProps: rowsPerPageMenuListProps,
            },
        }}
        ActionsComponent={({count, page, rowsPerPage, onPageChange}) => (
            <MHPaginationActions {...{count, page, size: rowsPerPage, onPageChange}} />
        )}
        labelDisplayedRows={() => null}
        classes={{
            root: styles.paginationRoot,
            select: styles.paginationInput,
            selectLabel: styles.paginationCaption,
            displayedRows: styles.paginationCaption,
        }}
    />
);
